import { render } from "./Index.vue?vue&type=template&id=01a718af&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=01a718af&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=01a718af&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3734146499/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a718af"]])

export default __exports__